import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { groupsSelectors } from './deviceGroups.state';
import { DeviceGroup, GroupDevice } from './deviceGroups.types';
import { DeviceScreen } from 'src/features/companies/companies.types';
import { Firmware } from 'src/features/firmwares/firmwares.types';

export const useDeviceGroupsState = (): RootState['deviceGroups'] => {
  const collections = useSelector<RootState, RootState['deviceGroups']>(state => state.deviceGroups);

  useDebugValue(collections);

  return collections;
};

export const useDeviceGroups = (): DeviceGroup[] => {
  const collections = useSelector<RootState, RootState['deviceGroups']>(state => state.deviceGroups);

  const result = groupsSelectors.selectAll(collections);

  useDebugValue(result);

  return result;
};

export const useDeviceGroupById = (id: string): DeviceGroup | null => {
  const collections = useSelector<RootState, RootState['deviceGroups']>(state => state.deviceGroups);

  const result = groupsSelectors.selectById(collections, id) || null;

  useDebugValue(result);

  return result;
};

export const useDeviceGroupDevicesById = (id: string): GroupDevice[] => {
  const collections = useSelector<RootState, RootState['deviceGroups']>(state => state.deviceGroups);

  const result = groupsSelectors.selectById(collections, id);

  useDebugValue(result?.devices);

  return result?.devices || [];
};

export const useDeviceGroupScreensById = (id: string): DeviceScreen[] => {
  const collections = useSelector<RootState, RootState['deviceGroups']>(state => state.deviceGroups);

  const result = groupsSelectors.selectById(collections, id);

  useDebugValue(result?.devices);

  return result?.deviceScreens || [];
};

export const useDeviceGroupFirmwaresById = (id: string): Firmware[] => {
  const collections = useSelector<RootState, RootState['deviceGroups']>(state => state.deviceGroups);

  const result = groupsSelectors.selectById(collections, id);

  useDebugValue(result?.devices);

  return result?.firmwares || [];
};
